import { Loader2 } from "lucide-react";
import { Badge } from "../../../../components/ui/badge";
import { TableCell, TableRow } from "../../../../components/ui/table";
import { OptroWorkStepSummary } from "../../../../models/audit/workStep";

// Stand-in for a work step still importing from Optro, built from the import
// selection so the table has a row for it before the real one exists. Not
// clickable: there is no work step to open yet.
export const ImportingWorkStepRow = ({
  workStep,
}: {
  workStep: OptroWorkStepSummary;
}) => (
  <TableRow
    aria-busy="true"
    className="gradient-sweep-row text-stone-400 hover:bg-transparent"
  >
    <TableCell className="border-x">
      <div className="flex items-center gap-2 overflow-hidden">
        <span className="shrink-0 font-mono text-xs">
          {workStep.externalRef}
        </span>
        <p className="truncate" title={workStep.name}>
          {workStep.name}
        </p>
      </div>
    </TableCell>
    <TableCell className="text-sm border-r">
      <div className="truncate">{workStep.section || "-"}</div>
    </TableCell>
    <TableCell className="text-sm border-r">
      <div className="truncate">{workStep.subsection || "-"}</div>
    </TableCell>
    <TableCell className="text-sm border-r">
      <div className="truncate">{workStep.preparer || "-"}</div>
    </TableCell>
    <TableCell className="text-sm border-r">
      <Badge
        variant="secondary"
        className="gap-1.5 py-1 font-medium bg-stone-100 text-stone-500 hover:bg-stone-100"
      >
        <Loader2 className="h-3 w-3 animate-spin motion-reduce:animate-none" />
        Importing
      </Badge>
    </TableCell>
  </TableRow>
);
